<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseSelect } from "@/components";

export default {
  name: "InvoiceFilter",
  components: {
    BaseSelect,
  },
  props: {
    currentYearNumber: String,
    currentMonthNumber: String,
  },
  data() {
    return {
      ApplicationTypes: [],
      selectedYear: -1,
      selectedMonth: -1,
      selectedAppType: 0,
      customerId: null,
    };
  },
  mounted() {
    this.customerId = this.$route.params.customerId;
    this.getFilter();
  },
  computed: {
    ...mapGetters(["getFilterList", "getInvoiceFilter", "getUserInfo"]),
    getUserType() {
      const REPRESENTATIVE_CODE = 3;
      const userType = this.getUserInfo.memberType;
      return userType && userType === REPRESENTATIVE_CODE;
    },
    getServerSideDate() {
      return this.getUserInfo.date;
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const previousYear = currentYear - 1;
      const nextYear = currentYear + 1;
      const splitDate = String(this.getServerSideDate).split("-")[1];
      const splitMonth = String(splitDate).split("-")[0];
      let currentMonth = parseInt(splitMonth);

      if (currentMonth >= 0 && currentMonth <= 9) {
        return [
          { code: -1, label: "Seçiniz" },
          { code: 0, label: previousYear },
          { code: 1, label: currentYear },
        ];
      } else if (currentMonth >= 10 && currentMonth <= 12) {
        return [
          { code: -1, label: "Seçiniz" },
          { code: 1, label: currentYear },
          { code: 2, label: nextYear },
        ];
      } else {
        return [
          { code: -1, label: "Seçiniz" },
          { code: 0, label: previousYear },
          { code: 1, label: currentYear },
        ];
      }
    },
    availableMonths() {
      return [
        { code: -1, label: "Seçiniz" },
        { code: 1, label: "Ocak" },
        { code: 2, label: "Şubat" },
        { code: 3, label: "Mart" },
        { code: 4, label: "Nisan" },
        { code: 5, label: "Mayıs" },
        { code: 6, label: "Haziran" },
        { code: 7, label: "Temmuz" },
        { code: 8, label: "Ağustos" },
        { code: 9, label: "Eylül" },
        { code: 10, label: "Ekim" },
        { code: 11, label: "Kasım" },
        { code: 12, label: "Aralık" },
      ];
    },
  },
  methods: {
    ...mapActions(["fillFilter", "getInvoiceList"]),
    ...mapMutations(["setInvoiceFilter"]),
    getFilter() {
      this.fillFilter().then((res) => {
        if (res.data) {
          const ApplicationTypesList = this.getFilterList.filter(
            (o) => o.name === "ApplicationTypes"
          );

          if (ApplicationTypesList.length > 0)
            this.ApplicationTypes = ApplicationTypesList[0].values;
          this.ApplicationTypes.unshift({ code: -1, label: "Hepsi" });
          this.selectedAppType = -1;
          this.setInvoiceFilter({
            page: 1,
            size: 100,
            filter: {},
          });
        }
      });
    },
    applyFilters() {
      this.$emit("filterChangeResponse", false);

      const filters = {
        page: 1,
        size: 100,
        filter: {},
      };
      if (this.selectedYear !== -1 && this.selectedYear?.code !== -1) {
        filters.filter.Year = this.selectedYear.label;
      }
      if (this.selectedMonth !== -1) {
        filters.filter.Month = this.selectedMonth;
      }
      if (this.selectedAppType !== -1) {
        filters.filter.ApplicationTypes = this.selectedAppType.toString();
      }

      this.setInvoiceFilter(filters);
      this.getInvoiceList(this.customerId).then(() => {
        this.$emit("filterChangeResponse", true);
      });
    },

    changeInvoiceYear(value) {
      this.selectedYear = value;
      this.applyFilters();
    },

    changeInvoiceMonth(value) {
      this.selectedMonth = value.code;
      this.applyFilters();
      this.$emit("monthChanged", this.selectedMonth);
    },

    changeApplicationTypes(value) {
      this.selectedAppType = value?.code;
      this.applyFilters();
    },

    resetFilter(filterName) {
      delete this.getInvoiceFilter.filter[filterName];
      delete this.getInvoiceFilter[filterName];
    },
  },
};
</script>
<template>
  <div class="filter">
    <base-select
      fieldLabel="Yıl"
      id="invoiceYearFilter"
      @change="changeInvoiceYear"
      :clearable="false"
      :options="availableYears"
      :selectedId="parseInt(selectedYear)"
      class="filter-selectbox"
    />
    <base-select
      fieldLabel="Ay"
      id="invoiceMonthFilter"
      @change="changeInvoiceMonth"
      :clearable="false"
      :options="availableMonths"
      :selectedId="parseInt(selectedMonth)"
      class="filter-selectbox"
      v-if="!getUserType"
    />
    <base-select
      fieldLabel="Veri Grubu"
      :id="'applicationTypeFilter'"
      @change="changeApplicationTypes"
      :clearable="false"
      :options="ApplicationTypes"
      :selectedId="selectedAppType"
      class="filter-selectbox"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 917px) {
    width: 100%;
    flex-flow: column;
    align-items: unset;
  }
  .filter-selectbox {
    margin-right: 10px;

    @media (max-width: 768px) {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }

    &:first-child ::v-deep .v-select.veri-dagitim-selectbox,
    &:first-child
      ::v-deep
      .v-select.veri-dagitim-selectbox
      .vs__dropdown-toggle,
    &:nth-child(2) ::v-deep .v-select.veri-dagitim-selectbox,
    &:nth-child(2)
      ::v-deep
      .v-select.veri-dagitim-selectbox
      .vs__dropdown-toggle {
      width: 150px;
      min-width: 165px;
      @media (max-width: 992px) {
        width: 100%;
      }
    }
    ::v-deep .v-select.veri-dagitim-selectbox .vs__dropdown-toggle {
      height: 48px;
    }
    ::v-deep .v-select.veri-dagitim-selectbox .vs__selected-options {
      font-size: 14px !important;
    }
    ::v-deep .v-select.veri-dagitim-selectbox .vs__search {
      padding: 0px;
    }
    ::v-deep .form-control-label {
      display: block;
      font-size: 12px;
      color: var(--color-primary-black-metallic);
      top: 0px;
      background: transparent;
      font-weight: 500;
      margin: 0px 0px 5px 0px;
      padding: 0px;
    }
    &:last-child {
      margin-right: 0px;
      min-width: 280px;
    }
  }
}
</style>
